import { render, staticRenderFns } from "./footnotes.vue?vue&type=template&id=4225d0a7&scoped=true"
import script from "./footnotes.vue?vue&type=script&lang=js"
export * from "./footnotes.vue?vue&type=script&lang=js"
import style0 from "./footnotes.vue?vue&type=style&index=0&id=4225d0a7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4225d0a7",
  null
  
)

export default component.exports